import React, {useState, useRef, useEffect} from "react";
import {useSelector} from "react-redux";
import {useActivate, useUnactivate} from "react-activation";
import {message, Modal, Breadcrumb, Space, Button, Form, Row, Col, Input, Table} from "antd";
import {FileAddOutlined, DeleteOutlined, CloseCircleOutlined, FileSearchOutlined, FileTextOutlined} from "@ant-design/icons";
import ChuangShiOS from "chuangshi-os-website-component";

import Application from "../../common/Application";

import Style from "./Index.module.css";

const MerchantIndex = (props) => {
    const store = useSelector((store) => store);
    const [form] = Form.useForm();
    const request = useRef(false);
    const [isLoad, setIsLoad] = useState(false);
    const [isError, setIsError] = useState(false);
    const [tableHeight, setTableHeight] = useState(0);
    const [merchantPageIndex, setMerchantPageIndex] = useState(1);
    const [merchantPageSize, setMerchantPageSize] = useState(store.main.pageSize);
    const [merchantIdList, setMerchantIdList] = useState([]);
    const [merchantTotal, setMerchantTotal] = useState(0);
    const [merchantList, setMerchantList] = useState([]);

    useEffect(() => {
        if (store.main.userName) {
            ChuangShiOS.Notification.emit("main_menu_active", {url: "/merchant/index"});

            handleSearchMerchant();
        }

        //eslint-disable-next-line
    }, [store.main.userName]);

    useEffect(() => {
        handleLoadMerchant(merchantPageIndex, store.main.pageSize);

        //eslint-disable-next-line
    }, [store.main.pageSize]);

    useActivate(() => {
        ChuangShiOS.Notification.emit("main_set_scroll_top", {});

        handleLoadMerchant(merchantPageIndex, merchantPageSize);
    });

    useUnactivate(() => {
        ChuangShiOS.Notification.emit("main_get_scroll_top", {});
    });

    const handleSearchMerchant = () => {
        handleLoadMerchant(1, merchantPageSize);
    };

    const handleLoadMerchant = (merchantPageIndex, merchantPageSize) => {
        if (request.current) {
            return;
        }
        request.current = true;

        setIsLoad(true);

        let data = form.getFieldsValue();
        data.pageIndex = merchantPageIndex;
        data.pageSize = merchantPageSize;

        ChuangShiOS.Util.request(props, {
            url: Application.host + "/windeal/merchant/business/website/v1/list",
            data: data,
            success: (response) => {
                setMerchantPageIndex(merchantPageIndex);
                setMerchantPageSize(merchantPageSize);
                setMerchantIdList([]);
                setMerchantTotal(response.data.total);
                setMerchantList(response.data.list);
            },
            error: (response) => {
                message.error({content: response.message, duration: 1});
            },
            complete: (response) => {
                request.current = false;

                setIsLoad(false);
                setIsError(
                    typeof response.data == "undefined" ||
                        response.data.total == "undefined" ||
                        response.data.total == null ||
                        response.data.list == "undefined" ||
                        response.data.list == null
                );
            },
        });
    };

    const handleAddMerchant = () => {
        ChuangShiOS.Util.navigateTo(props, {
            url: "/merchant/add",
        });
    };

    const handleEditMerchant = (merchantId) => {
        ChuangShiOS.Util.navigateTo(props, {
            url: "/merchant/edit/" + merchantId,
        });
    };

    const handleDelMerchant = () => {
        if (merchantIdList.length == 0) {
            return;
        }

        if (request.current) {
            return;
        }

        Modal.confirm({
            title: "是否确认操作？",
            content: "本次数据操作后将无法恢复",
            okText: "确认",
            okType: "danger",
            okButtonProps: {
                icon: <DeleteOutlined />,
            },
            cancelText: "取消",
            cancelButtonProps: {
                icon: <CloseCircleOutlined />,
            },
            onOk: () => {
                if (request.current) {
                    return;
                }
                request.current = true;

                setIsLoad(true);

                message.loading({
                    content: "正在加载",
                    key: "isLoad",
                    duration: 0,
                });

                ChuangShiOS.Util.request(props, {
                    url: Application.host + "/windeal/merchant/business/website/v1/delete",
                    data: {
                        merchantIdList: merchantIdList,
                    },
                    success: (response) => {
                        message.success({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });

                        request.current = false;

                        setIsLoad(false);
                        setMerchantIdList([]);

                        handleLoadMerchant(merchantPageIndex, merchantPageSize);
                    },
                    error: (response) => {
                        message.error({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });

                        request.current = false;

                        setIsLoad(false);
                    },
                    complete: (response) => {},
                });
            },
        });
    };

    const handleChangeMerchantIdList = (merchantIdList) => {
        setMerchantIdList(merchantIdList);
    };

    const handleChangeMerchantPagination = (merchantPageIndex, merchantPageSize) => {
        handleLoadMerchant(merchantPageIndex, merchantPageSize);
    };

    return (
        <div className={Style.page}>
            <div className={Style.header}>
                <div className={Style.header_title}>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <span>首页</span>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <span>{store.main.menuName}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <div className={Style.header_title_text}>{store.main.sidebarName}</div>
                </div>
                <div className={Style.header_button}>
                    <Space>
                        <Button.Group>
                            <Button icon={<FileAddOutlined />} size="large" onClick={handleAddMerchant}>
                                新增
                            </Button>
                            <Button
                                loading={isLoad}
                                disabled={merchantIdList.length == 0}
                                icon={<DeleteOutlined />}
                                size="large"
                                onClick={handleDelMerchant}
                            >
                                删除
                            </Button>
                        </Button.Group>
                        <Button loading={isLoad} icon={<FileSearchOutlined />} type="primary" size="large" onClick={handleSearchMerchant}>
                            查询
                        </Button>
                    </Space>
                </div>
            </div>
            <ChuangShiOS.Content className={Style.content} isLoad={isLoad} isEmpty={false} isError={isError} isScroll={store.main.isFixedContent}>
                <Form form={form}>
                    <Row>
                        <Col span={6}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="商户名称"
                                labelAlign={"left"}
                                name="merchantName"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入商户名称",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入商户名称" onPressEnter={handleSearchMerchant} />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="商户代码"
                                labelAlign={"left"}
                                name="merchantCode"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入商户代码",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入商户代码" onPressEnter={handleSearchMerchant} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <div
                    ref={(ref) => {
                        if (ref != null && tableHeight == 0 && tableHeight != ref.clientHeight) {
                            setTableHeight(ref.clientHeight);
                        }
                    }}
                    className={store.main.isFixedContent ? Style.card_table : null}
                >
                    <Table
                        size="small"
                        rowKey={(record) => record.merchantId}
                        columns={[
                            {
                                title: "商户名称",
                                dataIndex: "merchantName",
                            },
                            {
                                title: "商户代码",
                                dataIndex: "merchantCode",
                            },
                            {
                                title: "城市名称",
                                dataIndex: "cityName",
                            },
                            {
                                title: "品牌名称",
                                dataIndex: "brandName",
                            },
                            {
                                title: "操作",
                                width: 150,
                                render: (text, record, recordIndex) => (
                                    <Space>
                                        <Button icon={<FileTextOutlined />} size="default" onClick={() => handleEditMerchant(record.merchantId)}>
                                            修改
                                        </Button>
                                    </Space>
                                ),
                            },
                        ]}
                        dataSource={merchantList}
                        rowSelection={{
                            fixed: true,
                            selectedRowKeys: merchantIdList,
                            onChange: handleChangeMerchantIdList,
                        }}
                        scroll={store.main.isFixedContent ? {y: tableHeight - 130} : {}}
                        pagination={{
                            size: "default",
                            showQuickJumper: true,
                            showSizeChanger: true,
                            current: merchantPageIndex,
                            pageSize: merchantPageSize,
                            total: merchantTotal,
                            showTotal: (total, range) => "显示" + range[0] + "到" + range[1] + "条,共有" + total + "条",
                            onChange: handleChangeMerchantPagination,
                            onShowSizeChange: handleChangeMerchantPagination,
                        }}
                    />
                </div>
            </ChuangShiOS.Content>
            <div className={Style.footer}></div>
        </div>
    );
};

MerchantIndex.propTypes = {};

MerchantIndex.defaultProps = {};

export default MerchantIndex;
